module.exports = __webpack_public_path__ + "img/Butterfly_00063.64490545.png";